
import * as sTypes from 'Flow2/components/Share/ShareTypes/ShareTypes';
import * as dt from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

export const getSearchConfig = ({ viewMode, config, configName, noView = '' }) => {
    let fields;
    if (config && config[configName].length > 0) {
        fields = config[configName]
            .filter((el) => {
                if (el.params && noView && el.params[noView]) return false;
                if (el.type && el.type === 'text') return true;
                if (el.params && el.params[viewMode]) return true;
                return false;
            })
    }
    return fields;
};

export const checkFullTxtSearch = ({ params = {}, type, getState }) => {
    console.log("LOGS: checkFullTxtSearch params", params);
    let isDsgvo = params.isDsgvo;
    if (dt.isPorscheArchiv() && type == sTypes.FULLTXT && isDsgvo) {
        let flexObjects = getState().flex.flexObjects;
        if (flexObjects.isSearchFullToFields) {
            let config = getState().metadata.config;
            let fields;
            if (params && params.fields) fields = params.fields;
            let meta = getSearchConfig({ viewMode: 'fulltext_all', config, configName: 'clip', noView: 'no_dsgvo' });
            let sFields = [];
            if (meta && meta.length) {
                meta.forEach(item => {
                    let found;
                    let obj = {};
                    obj.field = item.field;
                    obj.value = params.keyword;
                    obj.type = 'contains';
                    if (fields && fields.length) {
                        found = fields.find(el => el.field === item.field);
                        if (found) {
                            obj.value = found.value;
                            obj.type = found.type;
                        }
                    }
                    sFields.push(obj);
                });
            }
            sFields = sFields.filter(item => item.field !== 'filecontent');
            sFields = [sTypes.BEGIN_OR, ...sFields, sTypes.END_OR];
            return { type: sTypes.FULLTXT, fields: sFields };
        }
    }
    return null;
}

export const checkSearchByFields = ({ getState, fields, params }) => {
    let flexObjects = getState().flex.flexObjects;
    if (dt.isPorscheArchiv()
        && (params.isFullToFields || (fields[0].field == sTypes.IS_FULLTOFIELDS && fields[0].value))
        && flexObjects.isSearchFullToFields) {
        fields = fields.filter(fi => fi.field != sTypes.IS_FULLTOFIELDS);
        fields.unshift(sTypes.BEGIN_OR);
        let last = fields.splice(fields.length - 1);
        fields.push(sTypes.END_OR);
        fields.push(last[0]);
    }
    return fields;
}

export const isMultiSort = ({ getState, params }) => {
    let sortObjects = getState().sort.sortObjects;
    if (sortObjects && sortObjects.sortFields && sortObjects.sortFields.length
        && params.startMultiSort
    ) {
        return true;
    }
    return false;
}

export const checkMultiSortByFields = ({ getState, fields = [], params }) => {
    let nFields = [...fields];
    if (nFields && nFields.length) {
        if (isMultiSort({ getState, params })) {
            let sortObjects = getState().sort.sortObjects;
            nFields = [...nFields, ...sortObjects.sortFields];
        }
        nFields = nFields.filter(fi => fi.field !== 'startMultiSort');
    }
    return nFields;
}

export const checkMultiSort = ({ getState, fields = [], extObj, type, params }) => {
    if (type === 'fulltext') {
        let obj = { ...extObj };
        if (obj && obj.fields) {
            if (isMultiSort({ getState, params })) {
                let sortObjects = getState().sort.sortObjects;
                let idxOf = obj.fields.findIndex(el => el.type == 'ORDER');
                let tmp = obj.fields.splice(idxOf, 1);
                obj.fields = [...obj.fields, ...tmp, ...sortObjects.sortFields];
            }
        }
        return obj;
    }
    if (type === 'byfields') return checkMultiSortByFields({ getState, fields, params });
}

export const getAllTxtSearchFields = ({ allTxtValue = '', getState }) => {
    let config = getState().metadata.config;
    let meta = getSearchConfig({ viewMode: 'byfields_all', config, configName: 'clip' });
    let sFields = [];
    if (meta && meta.length) {
        meta.forEach(item => {
            let obj = {};
            obj.field = item.field;
            obj.value = allTxtValue;
            obj.type = 'contains';
            sFields.push(obj);
        });
    }
    sFields = [sTypes.BEGIN_OR, ...sFields, sTypes.END_OR];
    return sFields;
}

export const checkAllTxtSearch = ({ getState, fields = [] }) => {
    let found = fields.find(item => item.field === 'allsearch');
    let allTxtFields;
    if (found && found.value) {
        allTxtFields = getAllTxtSearchFields({ getState, allTxtValue: found.value });
        let newFields = [...allTxtFields, ...fields];
        newFields = newFields.filter(item => item.field !== found.field);
        return newFields;
    }
    return fields;
}

export const checkDateGroup = ({ newFields, item, isFirst }) => {
    let found = sTypes.FLEX_DATE_OBJ[item.field];
    let value = item.value;
    let type = item.type;
    if (value.includes("T")) value = dt.subStringBefore(value, "T");
    if (found[type]) {
        newFields.push(sTypes.BEGIN_GROUP);
        newFields.push({ field: found[type][0].field, type: found[type][0].type, value });
        if (isFirst) {
            newFields.push(sTypes.BEGIN_OR);
            isFirst = false;
        } else newFields.push(sTypes.END_OR);
        newFields.push({ field: found[type][1].field, type: found[type][1].type, value });
        newFields.push(sTypes.END_GROUP)
    }

    return { newFields, isFirst };
}

export const checkOneDate = ({ newFields, item }) => {
    let found = sTypes.FLEX_DATE_OBJ[item.field];
    let value = item.value;
    let type = item.type;
    if (value.includes("T")) value = dt.subStringBefore(value, "T");
    if (found[type]) {
        newFields.push({ field: found[type][0].field, type: found[type][0].type, value });
        if (found[type][1]) {
            newFields.push({ field: found[type][1].field, type: found[type][1].type, value });
        }

    }
    return newFields;
}

export const checkFlexDate = ({ params }) => {
    if (dt.isPorscheArchiv()) {
        if (params && params.fields && params.fields.length) {
            let exists = params.fields.filter(item => sTypes.FLEX_DATE_OBJ[item.field]);
            if (exists && exists.length > 0 && !params.isProfi) exists = exists.filter(item => item.type != sTypes.CONTAINS);
            if (exists) {
                let newFields = [];
                let isFirst = true;
                params.fields.forEach(item => {
                    if (sTypes.FLEX_DATE_OBJ[item.field]) {
                        if (params.isProfi && item.type == sTypes.CONTAINS) item.type = 'less_than';
                        if (item.type != sTypes.CONTAINS) {
                            if (exists.length == 2) {
                                const checkObj = checkDateGroup({ newFields, item, isFirst });
                                newFields = checkObj.newFields;
                                isFirst = checkObj.isFirst;
                            } else if (exists.length == 1) {
                                newFields = checkOneDate({ newFields, item });
                            }
                        }
                    } else {
                        newFields.push(item);
                    }
                });
                params.fields = newFields;
                return params;
            }
        }
    }
    return params;
}

export const getDDConfig = ({ viewMode, config, configName, searchType, exceptData = [] }) => {
    let fields;
    if (config && config[configName].length > 0) {
        fields = config[configName]
            .filter((el) => {
                if (el.type && el.type === searchType && !exceptData.some(entry => entry == el.field)) return true;
                if (viewMode && el.params && el.params[viewMode]) return true;
                return false;
            })
    }
    return fields;
};

export const convertSearchType = ({ searchType, config, fields, changeType, exceptData = [] }) => {
    let meta = getDDConfig({ config, configName: 'clip', searchType, exceptData });
    let sFields = [];
    if (fields && fields.length) {
        fields.forEach(item => {
            if (meta.find(el => el.field === item.field)) {
                if (changeType) {
                    if (searchType === sTypes.MULTISELECT) {
                        let tmp = item.value.split(";")
                        if (tmp && tmp.length) {
                            sFields.push(sTypes.BEGIN_OR);
                            tmp.forEach(entry => {
                                sFields.push({ field: item.field, type: sTypes.EQUAL, value: entry });
                            })
                            sFields.push(sTypes.END_OR);

                        }
                    }
                    else sFields.push({ ...item, type: changeType });
                }
            } else sFields.push(item);
        });
        if (sFields && sFields.length) return sFields;
    }
    return fields;
}

export const checkSearchFields = ({ getState, fields }) => {
    if (dt.isPorscheArchiv()) {
        let config = getState().metadata.config;
        fields = convertSearchType({ config, fields, searchType: sTypes.DROPDOWN, changeType: sTypes.EQUAL, exceptData: ['content'] });
        fields = convertSearchType({ config, fields, searchType: sTypes.MULTISELECT, changeType: sTypes.EQUAL });
        fields = convertSearchType({ config, fields, searchType: sTypes.NUMBER, changeType: sTypes.EQUAL });
    }
    return fields;
}
